import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { GetGrantByIdAPI } from "../../../API/GrantsAPI";
import { CompanyContext } from "../../../Contexts/CompanyContext";
import CardHeader from "../../../antd/components/CardHeader";
import useLoading from "../../../Hooks/useLoading";
import Loader from "../../../Components/Shared/Loader";
import useCan from "../../../Hooks/useCan";
import { ExternalRoles } from "../../../Static/Roles";
import { AuthContext } from "../../../Contexts/AuthContext";
import { FinancialLinesService } from "../../../antd/services/financialLines";
import { AllStates } from "../../../Utils/AllStates";
import { AllSectors } from "../../../Utils/AllSectors";
import { AllCompanySizes } from "../../../Utils/AllCompaniesSizes";
import CardIconCustom from "../../../../src/antd/components/card/title/cardIcon";
import { HeartFilled, HeartOutlined } from "@ant-design/icons";
import { Button, Layout, Typography } from "antd";
import { IResponseProps } from "../../../Interfaces/IResponseProps";

export default function GrantsLineInfo() {
    const canView = useCan({ rolesCan: ["Internal", ...ExternalRoles] });
    const { company } = useContext(CompanyContext);
    const { loading, toggleLoading } = useLoading();
    const { id } = useParams();
    const { state } = useLocation()
    const navigate = useNavigate()
    const { userEmail } = useContext(AuthContext);
    const [grants, setGrants] = useState<any>({})
    const [isFavorite, setIsFavorite] = useState<boolean>(false)

    const getGrant = async () => {
        toggleLoading(true);
        try {
            let resp

            if (state.typeOfFinancing === 0 || state.typeOfFinancing === 1) {
                resp = await GetGrantByIdAPI(id!, state.typeOfFinancing)
            } else {
                const fetch1 = await GetGrantByIdAPI(state.grants.id, 0)
                const fetch2 = await GetGrantByIdAPI(state.grants.id, 1)


                if (fetch1 !== null || fetch1 !== undefined) {
                    resp = fetch1;

                }

                if (fetch2 !== null && fetch2 !== undefined) {

                    resp = fetch2;
                }
            }

            const favData = await FinancialLinesService.getFavorites(company.id)
            let found = false;

            for (let element of favData.data) {
                if (isFavorite === false) {
                    if (element.favoritesGrantsId === resp.data.financingLines.id) {
                        found = true;
                    }
                }
            }

            found ? setIsFavorite(true) : setIsFavorite(false)


            setGrants(resp.data)
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    const updateFav = async () => {
        toggleLoading(true);
        try {
            debugger
            let resp: IResponseProps;
            if (grants != undefined) {
                if (grants.financingLines.typeOfFinancing == 1) {
                    resp = await FinancialLinesService.setFavorite({
                        CompanyId: company.id,
                        FavoritesGrantDescription: grants.summary,
                        FavoritesGrantsName: grants.financingLines.title,
                        FavoritesGrantOrganism: grants.financingLines?.bankName,
                        FavoritesGrantsId: grants.financingLines.id,
                        UserEmail: userEmail
                    })
                } else {
                    await FinancialLinesService.setFavorite({
                        CompanyId: company.id,
                        FavoritesGrantDescription: grants.goal,
                        FavoritesGrantsName: grants.financingLines.title,
                        FavoritesGrantOrganism: grants.financingLines?.bankName,
                        FavoritesGrantsId: grants.financingLines.id,
                        UserEmail: userEmail
                    })
                }
            }
            getGrant();
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    };

    useEffect(() => {
        getGrant();
    }, []);

    const getStateLabels = (coverage: any) => {
        const states = coverage.split(';');
        return states.map((state: any) => {
            const foundState = AllStates.find(s => s.value === state);
            return foundState ? foundState.label : state;
        }).join('; ');
    };
    return (
        <Layout style={{
            background: 'white',
            padding: '0 30px 30px',
            marginTop: '16px',
            borderRadius: '8px'
        }}>
            {loading && <Loader />}
            <CardHeader
                pageName={grants.financingLines?.title}
                hasPageBefore={true}
                pageBeforeName={"Buscador de Linhas"}
                linkPageBefore={`/grantsSearcher/${company.id}`}
                isToHome={true}
            />
            <div className='card-body'>
                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                    <CardIconCustom
                        text={`${grants.financingLines?.bankName || 'Nome do Banco'} - ${grants.financingLines?.title || 'Nome da Linha'}`}
                        extra={<Button type="text"
                            onClick={updateFav}>{isFavorite ? <HeartFilled style={{ color: "white", fontSize: "32px" }} />
                                : <HeartOutlined className="heart-icon-blue" style={{ color: "white", fontSize: "32px" }} />}
                        </Button>}
                    />
                    <div style={{ margin: '25px 16px 0px 16px', fontFamily: 'Century Gothic' }}>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>

                            {grants.financingLines?.typeOfFinancing === 0 ? (
                                <>
                                    <Typography style={{ gridColumn: 'span 2', marginBottom: '24px' }}>
                                        <div style={{ display: 'block' }}>
                                            <strong>Objetivo: </strong>
                                        </div>
                                        {grants.goal || "-"}
                                    </Typography>
                                    <Typography style={{ marginBottom: '24px' }}>
                                        <div style={{ display: 'block' }}>
                                            <strong>Contrapartida: </strong>
                                        </div>
                                        {grants.counterpart || "-"}
                                    </Typography>
                                    <Typography style={{ marginBottom: '24px' }}>
                                        <div style={{ display: 'block' }}>
                                            <strong>Valores: </strong>
                                        </div>
                                        {grants.value || "-"}
                                    </Typography>
                                    <Typography style={{ marginBottom: '24px' }}>
                                        <div style={{ display: 'block' }}>
                                            <strong>Tipos de Beneficiários: </strong>
                                        </div>
                                        {grants.typeOfBeneficiary || "-"}
                                    </Typography>
                                    <Typography style={{ marginBottom: '24px' }}>
                                        <div style={{ display: 'block' }}>
                                            <strong>Prazos: </strong>
                                        </div>
                                        {grants.deadlines || "-"}
                                    </Typography>
                                    <Typography style={{ marginBottom: '24px' }}>
                                        <div style={{ display: 'block' }}>
                                            <strong>Abrangência: </strong>
                                        </div>
                                        {getStateLabels(grants.financingLines?.coverage) || "-"}
                                    </Typography>
                                </>
                            ) : (
                                <>
                                    <Typography style={{ gridColumn: 'span 2', marginBottom: '24px' }}>
                                        <div style={{ display: 'block' }}>
                                            <strong>Resumo: </strong>
                                        </div>
                                        {grants.summary || "-"}
                                    </Typography>
                                    <Typography style={{ marginBottom: '24px' }}>
                                        <div style={{ display: 'block' }}>
                                            <strong>O que pode ser financiado: </strong>
                                        </div>
                                        {grants.canBeFinanced || "-"}
                                    </Typography>
                                    <Typography style={{ marginBottom: '24px' }}>
                                        <div style={{ display: 'block' }}>
                                            <strong>Taxas: </strong>
                                        </div>
                                        {grants.interestRates || "-"}
                                    </Typography>
                                    <Typography style={{ marginBottom: '24px' }}>
                                        <div style={{ display: 'block' }}>
                                            <strong>Participação do Banco: </strong>
                                        </div>
                                        {grants.participationBank || "-"}
                                    </Typography>
                                    <Typography style={{ marginBottom: '24px' }}>
                                        <div style={{ display: 'block' }}>
                                            <strong>Prazo de carência: </strong>
                                        </div>
                                        {grants.gracePeriods || "-"}
                                    </Typography>
                                    <Typography style={{ marginBottom: '24px' }}>
                                        <div style={{ display: 'block' }}>
                                            <strong>Prazo Total: </strong>
                                        </div>
                                        {grants.totalTerm || "-"}
                                    </Typography>
                                    <Typography style={{ marginBottom: '24px' }}>
                                        <div style={{ display: 'block' }}>
                                            <strong>Abrangência: </strong>
                                        </div>
                                        {(grants.financingLines?.coverage?.split(',').map((sigla: string) => AllStates.find(e => e.value === sigla)?.label).filter(Boolean).join(', ')) || "-"}
                                    </Typography>
                                    <Typography style={{ marginBottom: '24px' }}>
                                        <div style={{ display: 'block' }}>
                                            <strong>Porte da empresa: </strong>
                                        </div>
                                        {(grants.companySize?.split(',').map((size: any) => AllCompanySizes.find(e => e.value === Number(size))?.label).filter(Boolean).join(', ')) || "-"}
                                    </Typography>
                                    <Typography style={{ marginBottom: '24px' }}>
                                        <div style={{ display: 'block' }}>
                                            <strong>Setores: </strong>
                                        </div>
                                        {(grants.sectors?.split(',').map((size: any) => AllSectors.find(e => e.value === Number(size))?.label).filter(Boolean).join(', ')) || "-"}
                                    </Typography>
                                </>
                            )}
                        </div>
                        <div style={{ textAlign: 'right', marginTop: '12px' }}>
                            <Button href={grants.financingLines?.linkLearnMore} type="link" target="_blank" style={{ padding: '0', color: '#0000A4' }}>Saiba mais...</Button>
                        </div>
                    </div>
                </div>
            </div >
        </Layout>
    );
}